// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._36mT6WwCQUNyXKEwOO670C{padding:0 .71429rem}._2sehfnGIdgECxYFop_PHyW{margin-bottom:.57143rem}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cheerList": "_36mT6WwCQUNyXKEwOO670C",
	"cheerList__item": "_2sehfnGIdgECxYFop_PHyW"
};
export default ___CSS_LOADER_EXPORT___;
